import React, { Fragment, useState } from 'react'
import { Form, Input, Button, Space, Skeleton } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { postData } from '../../../Actions/Action'

function ConnectionSettingsComponent(props) {
    const [testType, setTestType] = useState(false)
    const dispatch = useDispatch()
    const { connectionSettings, token, carrierId } = useSelector(state => state)

    const handleTypeChange = type => setTestType(type)

    const onFinish = values => {
        values = {
            ...values,
            testType,
            carrierId,
            installed_carrier_id: carrierId,
        }

        dispatch(
            postData(
                values,
                'GET_CONNECTION_SETTINGS',
                'submit_connection_settings',
                token
            )
        )
    }

    if (!connectionSettings) return <Skeleton active />

    return (
        <Fragment>
            <div className={'note-bx'}>
                <strong>Note!</strong> You must have a Roadrunner Freight account to use this application. If you do not have one, contact Roadrunner Freight at 414-615-1500.
            </div>
            <Form
                layout='vertical'
                name='connection_settings'
                className='connection-settings'
                size='large'
                initialValues={connectionSettings}
                onFinish={onFinish}>
                <Form.Item
                    className='mb-1'
                    label='Nickname'
                    name='nickname'
                    required={true}
                    rules={[{ required: !testType, message: 'Nickname is required' }]}>
                    <Input placeholder='e.g., Roadrunner' maxLength={50} />
                </Form.Item>
                <Form.Item
                    className='mb-1'
                    label='Username'
                    name='username'
                    required={true}
                    rules={[{ required: testType, message: 'Username is required' }]}>
                    <Input placeholder='Username' maxLength={50} />
                </Form.Item>
                <Form.Item
                    className='mb-1'
                    label='Password'
                    name='password'
                    required={true}
                    rules={[{ required: testType, message: 'Password is required' }]}>
                    <Input placeholder='Password' maxLength={50} />
                </Form.Item>
                
                <Form.Item style={{ textAlign: 'right', marginBottom: '0' }}>
                    <Space>
                        <Button
                            type='primary'
                            size='large'
                            htmlType='submit'
                            name='test'
                            onClick={() => handleTypeChange(true)}>
                            Test Connection
                        </Button>
                        <Button
                            type='primary'
                            size='large'
                            htmlType='submit'
                            name='save'
                            onClick={() => handleTypeChange(false)}>
                            Save Settings
                        </Button>
                    </Space>
                </Form.Item>
            </Form>
        </Fragment>
    )
}

export default ConnectionSettingsComponent
